"use strict";

const ContactCtrl = function (CRUDService, Notification, config, $state) {
    var ctrl = this;

    ctrl.model = {
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
      username: ""
    };

    ctrl.$onInit = function() {
      // get contact settings
      CRUDService.getAll(config.urls.settings).then(function (data) {
        ctrl.subjects = data.mailSubjects;
      });
    };

    ctrl.submit = function (form) {
      console.info(ctrl.model);
      if (form.$valid){
        CRUDService.save(ctrl.model, config.urls.contact).then(
          function(){
            Notification.success('Ihre Nachricht wurde erfolgreich versendet.');
            $state.go('main.home');
          },
          function(){
            Notification.error('Fehler beim Versenden der Nachricht.');
          }
        );
      }
    };
  }

ContactCtrl.$inject = ['CRUDService', 'Notification', 'config', '$state'];

module.exports = {
  template: require('./contact.component.html'),
  controller: ContactCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/components/contact/contact.component.js